import { RouterProvider } from "react-router"

import { createAppRouter } from "./router"
import { Providers } from "./providers"
import { bindSessionRouter } from "@/auth/session-lost"

const router = createAppRouter()
// A lost session (a failed refresh, another tab's sign-out) navigates this router.
bindSessionRouter(router)

/**
 * Scaffold (Task 0.1): the router is built once. LLD §7.1 builds it per mode
 * after `getConfig` and the session bootstrap settle (Phase 1, Task 2.5).
 */
export function App() {
  return (
    <Providers>
      <RouterProvider router={router} />
    </Providers>
  )
}
